import { Component, OnInit, HostListener } from "@angular/core";
import { Observable } from "rxjs";
import { HelpService } from "./help.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
	selector: "app-help",
	templateUrl: "./help.component.html",
	styleUrls: ["./help.component.scss"],
})
export class HelpComponent implements OnInit {
	help$: Observable<any>;
	@HostListener("document:keydown.escape @ 100 T", ["$event"]) onKeydownHandler(
		event: KeyboardEvent
	) {
		event.stopPropagation();
		event.stopImmediatePropagation();
		event.preventDefault();
		this.close();
	}

	constructor(private helpService: HelpService, private activeModal: NgbActiveModal) {}

	ngOnInit() {
		this.help$ = this.helpService.help$;
	}

	close = (): void => {
		this.activeModal.close();
		this.helpService.closeHelp();
	};
}
